import { render, staticRenderFns } from "./NoticeListMoveNotice.vue?vue&type=template&id=ca45ed24&"
import script from "./NoticeListMoveNotice.vue?vue&type=script&lang=ts&"
export * from "./NoticeListMoveNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports